import bootstrapIcons from "bootstrap-icons/bootstrap-icons.svg";
import type { Component } from "solid-js";

// Icon name is static on purpose
export const Icon: Component<{ name: string }> = ({ name }) => {
  return (
    <svg class="bi mx-1" width="1em" height="1em" fill="currentColor">
      <use href={`${bootstrapIcons}#${name}`} />
    </svg>
  );
};
export default Icon;
